import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimZeroDecimal'
})
export class TrimZeroDecimalPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || isNaN(value)) {
      return value;
    }

    const num = parseFloat(value);
    const isInteger = Number.isInteger(num);

    // Use Intl.NumberFormat to add commas
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: isInteger ? 0 : 2,
      maximumFractionDigits: 2
    }).format(num);

    return formatted;
  }
}
